export class LPRedirectUrl {
public ApCode: string;
public RpCode: string;
public PpLogin: string;
}